import { apiClient } from '../utils';
import { handleError } from './';

export const editBusiness = async (payload) => {
  try {
    const {
      bi,
      businessName,
      businessDescription,
      specifyAddress,
      location,
      selectedCity,
      nationalCode,
      categories,
    } = payload;
    let data = {};
    const serviceIds = (categories || []).reduce((acc, current) => {
      acc.push({ _id: current._id });
      return acc;
    }, []);

    data = {
      bi: bi,
      nm: businessName,
      dc: businessDescription,
      ad: specifyAddress,
      sr: serviceIds,
      ...(location.neighborhood?.point
        ? {
            ln: (location.neighborhood?.point || [])[0],
            lt: (location.neighborhood?.point || [])[1],
          }
        : {}),
      ...(selectedCity ? { ci: selectedCity._id } : {}),
      ...(location.neighborhood ? { ri: location.neighborhood._id } : {}),
      ...(nationalCode?.length ? { nc: nationalCode } : {}),
    };

    const { result } = await apiClient.post('/business/edit', { data });
    return result.business;
  } catch (error) {
    handleError(error);
    return error;
  }
};
